import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { IIndividualApplicant } from 'app/models/applicants/individual-applicant';
import { Observable } from 'rxjs';
import { IResidentialHistory } from 'app/models/applicants/residential-history';

@Injectable({providedIn: 'root'})
export class IndividualApplicantService {
  private api: string = environment.privateApi + 'IndividualApplicant/';
  private http = inject(HttpClient);

  createApplicant(applicant: IIndividualApplicant, entityId: number, entityType: string): Observable<IIndividualApplicant>{
    return this.http.post<IIndividualApplicant>( this.api + 'CreateApplicant/' + entityId + '/' + entityType, applicant);
  }

  updateApplicant(applicant: IIndividualApplicant): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'UpdateApplicant', applicant);
  }

  getApplicants(entityId: number, entityType: string, includeArchived: boolean): Observable<IIndividualApplicant[]>{
    return this.http.get<IIndividualApplicant[]>(this.api + 'GetApplicants/' + entityId + '/' + entityType + '/' + includeArchived);
  }

  archiveApplicant(applicantId: number, archived: boolean): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'ArchiveApplicant/' + applicantId + '/' + archived, null);
  }

  deleteApplicant(applicantId: number): Observable<boolean>{
    return this.http.delete<boolean>(this.api + 'DeleteApplicant/' + applicantId);
  }

  createResidentialHistory(history: IResidentialHistory): Observable<IResidentialHistory>{
    return this.http.post<IResidentialHistory>(this.api + 'CreateResidentialHistory', history);
  }

  updateResidentialHistory(history: IResidentialHistory): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'UpdateResidentialHistory', history);
  }

  getResidentialHistory(applicantId: number, includeArchived: boolean): Observable<IResidentialHistory[]>{
    return this.http.get<IResidentialHistory[]>(this.api + "GetResidentialHistory/" + applicantId + '/' + includeArchived);
  }

  archiveResidentialHistory(historyId: number, archived: boolean): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'ArchiveResidentialHistory/' + historyId + '/' + archived, null);
  }
}
